export default function CompanyIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        width="18"
        height="18"
        x="0"
        y="0"
        viewBox="0 0 512 512"
      >
        <g>
          <path
            d="M496 464h-8V200a8 8 0 0 0-8-8h-88V16a8 8 0 0 0-8-8H128a8 8 0 0 0-8 8v96H32a8 8 0 0 0-8 8v344h-8a8 8 0 0 0-8 8v24a8 8 0 0 0 8 8h480a8 8 0 0 0 8-8v-24a8 8 0 0 0-8-8zM392 208h80v256h-80zM136 24h240v440h-56V344a8 8 0 0 0-8-8H200a8 8 0 0 0-8 8v120h-56zm168 328v112h-40V352zm-56 0v112h-40V352zM40 128h80v336H40zm448 360H24v-8h464z"
            fill="#000000"
            opacity="1"
            data-original="#000000"
          ></path>
          <path
            d="M104 136H56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8zm-8 48H64v-32h32zM104 216H56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8zm-8 48H64v-32h32zM104 296H56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8zm-8 48H64v-32h32zM408 280h48a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8zm8-48h32v32h-32zM408 360h48a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8zm8-48h32v32h-32zM160 312h192a8 8 0 0 0 8-8v-64a8 8 0 0 0-8-8H160a8 8 0 0 0-8 8v64a8 8 0 0 0 8 8zm88-16h-32v-48h32zm16-48h32v48h-32zm80 48h-32v-48h32zm-176-48h32v48h-32zM160 216h192a8 8 0 0 0 8-8v-64a8 8 0 0 0-8-8H160a8 8 0 0 0-8 8v64a8 8 0 0 0 8 8zm88-16h-32v-48h32zm16-48h32v48h-32zm80 48h-32v-48h32zm-176-48h32v48h-32zM160 120h192a8 8 0 0 0 8-8V48a8 8 0 0 0-8-8H160a8 8 0 0 0-8 8v64a8 8 0 0 0 8 8zm88-16h-32V56h32zm16-48h32v48h-32zm80 48h-32V56h32zM168 56h32v48h-32z"
            fill="#000000"
            opacity="1"
            data-original="#000000"
          ></path>
        </g>
      </svg>
    </>
  );
}
